// extracted by mini-css-extract-plugin
export default {"successedEmail":"SubscribedMessage_successedEmail__ugXS+","letter":"SubscribedMessage_letter__p27FU","successedEmailSpan":"SubscribedMessage_successedEmailSpan__j+po-"};